import { useState } from "react";
import { supabase } from "../../supabaseClient";

export default function Jobs() {
  const [formData, setFormData] = useState({
    job: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    county: "",
    experience: "",
    availability: "",
    transportation: "",
    message: ""
  });

  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const jobs = [
    "Cleaning Technician"
    /* "Community Habilitation Worker",
    "Respite Worker",
    "Transportation Provider",
    "Yardwork Support Worker",
    "Laundry Support Worker",
    "DSP / Direct Support Professional",
    "Administrative Support",
    "Other"*/
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const resetForm = () => {
    setFormData({
      job: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      county: "",
      experience: "",
      availability: "",
      transportation: "",
      message: ""
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitting(true);
    setSuccessMessage("");
    setErrorMessage("");

    const applicationData = {
      job: formData.job,
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      phone: formData.phone,
      county: formData.county,
      transportation: formData.transportation,
      availability: formData.availability,
      experience: formData.experience,
      message: formData.message
    };

    const { error } = await supabase
      .from("job_applications")
      .insert([applicationData]);

    if (error) {
      console.error("Supabase insert error:", error);
      setErrorMessage(
        "There was an issue submitting your application. Please try again or contact Hopeful Horizons NY directly."
      );
      setSubmitting(false);
      return;
    }

    setSuccessMessage(
      "Thank you. Your application has been submitted successfully."
    );

    resetForm();
    setSubmitting(false);
  };

  return (
    <div style={styles.page}>
      <section style={styles.hero}>
        <h1 style={styles.title}>Apply for Jobs with Hopeful Horizons NY</h1>

        <p style={styles.subtitle}>
          Select the position you are interested in and complete the application
          form below. Our team will review your information and follow up
          regarding next steps.
        </p>
      </section>

      <form style={styles.form} onSubmit={handleSubmit}>
        {successMessage && (
          <div style={styles.successMessage}>{successMessage}</div>
        )}

        {errorMessage && (
          <div style={styles.errorMessage}>{errorMessage}</div>
        )}

        <div style={styles.field}>
          <label style={styles.label}>Job You Are Applying For *</label>
          <select
            name="job"
            value={formData.job}
            onChange={handleChange}
            required
            style={styles.input}
          >
            <option value="">Select a job</option>

            {jobs.map((job) => (
              <option key={job} value={job}>
                {job}
              </option>
            ))}
          </select>
        </div>

        <div style={styles.row}>
          <div style={styles.field}>
            <label style={styles.label}>First Name *</label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Last Name *</label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>
        </div>

        <div style={styles.row}>
          <div style={styles.field}>
            <label style={styles.label}>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Phone Number *</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>
        </div>

        <div style={styles.field}>
          <label style={styles.label}>County / Area You Can Work In *</label>
          <input
            type="text"
            name="county"
            value={formData.county}
            onChange={handleChange}
            placeholder="Example: Westchester, Bronx, Rockland, Orange County"
            required
            style={styles.input}
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Do You Have Reliable Transportation?</label>
          <select
            name="transportation"
            value={formData.transportation}
            onChange={handleChange}
            style={styles.input}
          >
            <option value="">Select one</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
            <option value="Sometimes">Sometimes</option>
          </select>
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Availability *</label>
          <textarea
            name="availability"
            value={formData.availability}
            onChange={handleChange}
            placeholder="Please list the days and times you are available to work."
            required
            style={styles.textarea}
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Relevant Experience</label>
          <textarea
            name="experience"
            value={formData.experience}
            onChange={handleChange}
            placeholder="Please describe any related experience, certifications, or skills."
            style={styles.textarea}
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Additional Message</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Share anything else you would like us to know."
            style={styles.textarea}
          />
        </div>

        <button type="submit" style={styles.button} disabled={submitting}>
          {submitting ? "Submitting..." : "Submit Application"}
        </button>
      </form>
    </div>
  );
}

const styles = {
  page: {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "40px 20px",
    fontFamily: "Arial, Helvetica, sans-serif"
  },
  hero: {
    textAlign: "center",
    marginBottom: "30px"
  },
  title: {
    color: "#2f6f89",
    fontSize: "2.2rem",
    marginBottom: "12px"
  },
  subtitle: {
    fontSize: "1.1rem",
    lineHeight: "1.6",
    color: "#444",
    maxWidth: "720px",
    margin: "0 auto"
  },
  form: {
    backgroundColor: "#ffffff",
    borderRadius: "18px",
    padding: "28px",
    boxShadow: "0 10px 28px rgba(0,0,0,0.12)",
    border: "1px solid #e8eef1"
  },
  row: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "18px"
  },
  field: {
    marginBottom: "18px"
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "700",
    color: "#2f6f89"
  },
  input: {
    width: "100%",
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid #cfd8dc",
    fontSize: "1rem",
    fontFamily: "Arial, Helvetica, sans-serif",
    boxSizing: "border-box"
  },
  textarea: {
    width: "100%",
    minHeight: "110px",
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid #cfd8dc",
    fontSize: "1rem",
    fontFamily: "Arial, Helvetica, sans-serif",
    resize: "vertical",
    boxSizing: "border-box"
  },
  button: {
    width: "100%",
    backgroundColor: "#2f6f89",
    color: "white",
    border: "none",
    padding: "14px 18px",
    borderRadius: "12px",
    fontSize: "1.05rem",
    fontWeight: "700",
    cursor: "pointer",
    marginTop: "8px"
  },
  successMessage: {
    backgroundColor: "#e8f5e9",
    color: "#1b5e20",
    padding: "12px",
    borderRadius: "10px",
    marginBottom: "18px",
    fontWeight: "700"
  },
  errorMessage: {
    backgroundColor: "#ffebee",
    color: "#b71c1c",
    padding: "12px",
    borderRadius: "10px",
    marginBottom: "18px",
    fontWeight: "700"
  }
};